export default __webpack_public_path__ + "static/media/S_CoreDream_2ExtraLight.72d63c82.woff";